export const productReducer = (state = { products: [] }, action) => {
    switch (action.type) {
        case "ALL_PRODUCT_REQUEST":
            return {
                loading: true,
                products: [],
            };
        case "ALL_PRODUCT_SUCCESS":
            return {
                loading: false,
                products: action.payload.products,
                productsCount: action.payload.productsCount,
                resultPerPage: action.payload.resultPerPage,
                filteredProductsCount: action.payload.filteredProductsCount,
            };
        case "ALL_PRODUCT_FAIL":
            return {
                loading: false,
                error: action.payload,
            };
        case "CLEAR_ERRORS":
            return {
                ...state,
                error: undefined,
            };

        default:
            return state;
    }
};

export const productDetailsReducer = (state = { product: [] }, action) => {
    switch (action.type) {
        case "PRODUCT_DETAILS_REQUEST":
            return {
                loading: true,
                product: [],
            };
        case "PRODUCT_DETAILS_SUCCESS":
            return {
                loading: false,
                product: action.payload,
            };
        case "PRODUCT_DETAILS_FAIL":
            return {
                loading: false,
                error: action.payload,
            };
        case "CLEAR_ERRORS":
            return {
                ...state,
                error: undefined,
            };

        default:
            return state;
    }
};

export const newReviewReducer = (state = {}, action) => {
    switch (action.type) {
        case "NEW_REVIEW_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "NEW_REVIEW_SUCCESS":
            return {
                loading: false,
                success: action.payload,
            };
        case "NEW_REVIEW_FAIL":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "NEW_REVIEW_RESET":
            return {
                ...state,
                success: false,
            };
        case "CLEAR_ERRORS":
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
};

export const productReviewsReducer = (state = { reviews: [] }, action) => {
    switch (action.type) {
        case "ALL_REVIEW_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "ALL_REVIEW_SUCCESS":
            return {
                loading: false,
                reviews: action.payload,
            };
        case "ALL_REVIEW_FAIL":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case "CLEAR_ERRORS":
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
};

export const reviewReducer = (state = {}, action) => {
    switch (action.type) {
        case "DELETE_REVIEW_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "DELETE_REVIEW_SUCCESS":
            return {
                ...state,
                loading: false,
                isDeleted: action.payload,
            };
        case "DELETE_REVIEW_FAIL":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "DELETE_REVIEW_RESET":
            return {
                ...state,
                isDeleted: false,
            };
        case "CLEAR_ERRORS":
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
};
